export default __webpack_public_path__ + "static/media/mobile_00.5eed76c4.png";